import React from "react";
import UnderConstruction from "../components/UnderConstruction";

const AircraftMaintenance = () => (
  <UnderConstruction
    eyebrow="Aircraft Maintenance"
    seoTitle="Aircraft Maintenance | Steck Aviation Management"
    seoDescription="Aircraft maintenance from Steck Aviation Management. Coming soon."
  />
);

export default AircraftMaintenance;
